import React from 'react';

import { useIntl } from 'react-intl';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import AiGenerativeRemixIcon from '@atlaskit/icon-lab/core/ai-generative-remix';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import { messages } from '../messages';

type RemixPasteMenuItemProps = {
	onClick: (event: React.SyntheticEvent<Element>) => void;
};

export const RemixPasteMenuItem = ({ onClick }: RemixPasteMenuItemProps): JSX.Element => {
	const intl = useIntl();
	// A/A experiment paired with cc_maui_create_keyword; called to balance exposures. Result unused.
	expValEquals('cc_maui_create_keyword_aa', 'isEnabled', true);
	return (
		<ToolbarDropdownItem
			testId="ai-paste-menu__remix"
			elemBefore={<AiGenerativeRemixIcon size="small" label="" />}
			onClick={onClick}
		>
			{expValEquals('cc_maui_create_keyword', 'isEnabled', true)
				? intl.formatMessage(messages.createFromSelection)
				: intl.formatMessage(aiConfigItemMessages.remixTitle)}
		</ToolbarDropdownItem>
	);
};
